<template>
  <div>

    <v-card outlined
            color="#488ba6"
            dark
            style="margin-bottom: 2em"
    >
      <v-card-title class="headline">{{ state.member.meeting.meetingInfo.name }}
      </v-card-title>


    </v-card>

    <v-form @submit.prevent="submitForm" ref="regForm" lazy-validation v-model="valid">
      <v-card outlined class="mb-5">

        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title>Contact Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>


          <v-text-field
              label="First Name"
              name="first-name"
              type="text"
              v-model="state.member.contact.first_name"
              :rules="[v => !!v || 'First Name is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Middle Name"
              name="middle-name"
              type="text"
              v-model="state.member.contact.middle_name"
          ></v-text-field>
          <v-text-field
              label="Last Name"
              name="last-name"
              type="text"
              v-model="state.member.contact.last_name"
              :rules="[v => !!v || 'Last Name is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Primary Degree"
              name="primary-degree"
              type="text"
              v-model="state.member.contact.primary_degree"
              :rules="[v => !!v || 'Primary Degree is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Address 1"
              name="address-1"
              type="text"
              v-model="state.member.contact.address_1"
              :rules="[v => !!v || 'Address 1 is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Address 2"
              name="address-2"
              type="text"
              v-model="state.member.contact.address_2"
          ></v-text-field>
          <v-text-field
              label="City"
              name="city"
              type="text"
              v-model="state.member.contact.city"
              :rules="[v => !!v || 'City is required']"
              required
          ></v-text-field>
          <v-select
              :items="state.appStage.states"
              label="State"
              item-text="text"
              item-value="val"
              v-model="state.member.contact.state"
              attach
              :rules="[v => !!v || 'First Name is required']"
              required
          ></v-select>
          <v-text-field
              label="Zip"
              name="zip"
              type="text"
              v-model="state.member.contact.zip"
              :rules="[v => !!v || 'Zip is required']"
              required
          ></v-text-field>
          <v-select
              :items="state.appStage.countries"
              label="Country"
              item-text="text"
              item-value="val"
              v-model="state.member.contact.country"
              attach
              :rules="[v => !!v || 'First Name is required']"
              required
          ></v-select>
          <v-text-field
              label="Primary Email"
              name="primary-email"
              type="text"
              v-model="state.member.contact.email"
              :rules="[v => !!v || 'Primary Email is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Primary Phone Number"
              name="phone"
              type="text"
              v-model="state.member.contact.phone"
              :rules="[v => !!v || 'Primary Phone is required']"
              required
          ></v-text-field>
          <v-text-field
              label="ACS ID"
              name="acs-number"
              type="text"
              v-model="state.member.contact.acs_number"
          ></v-text-field>
        </v-card-text>
      </v-card>
      <v-card outlined class="mb-5" v-for="(attachment, index) in state.member.attachments" :key="index">
        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title>Required Attachment #{{ index + 1 }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-file-input
              :label="attachment.label+' (max file size 8MB)'"
              v-model="attachment.file" :ref="attachment.name"
              :rules="[v => !!v || 'Attachemt is required']"
              required
          ></v-file-input>
          <v-btn v-if="attachment.link" :href="attachment.link" target="_blank">Worksheet (fill out and attach
            above)
          </v-btn>

        </v-card-text>
      </v-card>
      <v-card outlined class="mb-5" v-if="rsvpRequired.length > 0">
        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title>Special Events RSVP</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-for="(p, index) in rsvpRequired" :key="index">
            <h3>{{ p.name }} RSVP</h3>
            <v-combobox

                label="Names of Adults Attending"
                :name="p.name+'-rsvp'"
                v-model="p.adultRSVP"
                attach
                chips
                multiple
                persistent-hint
                hint="Press the enter key to add another name to your RSVP"
                :rules="[v => !!v || 'RSVP is required']"
                required
            ></v-combobox>

            <v-combobox
                v-if="p.childRsvpRequired"
                multiple
                chips
                persistent-hint
                hint="Press the enter key to add another name to your RSVP"
                label="Names of Children Attending"
                :name="p.name+'-rsvp'"
                v-model="p.childRSVP"
                attach
                :rules="[v => !!v || 'RSVP is required']"
                required
            ></v-combobox>
            <br><br><br>
          </div>
        </v-card-text>
      </v-card>
      <Donation/>
      <Review :form-total="formTotal.display"></Review>
      <v-card outlined v-if="formTotal.intVal > 0">

        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title>Payment</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>

          <v-select
              prepend-icon="mdi-credit-card"
              :items="ccTypes"
              label="Credit Card Type"
              item-text="text"
              item-value="val"
              v-model="state.payment.cc.type"
              attach
              :rules="[v => !!v || 'Card Number is required']"
              required
          ></v-select>
          <v-text-field
              label="Credit Card Number"
              name="cc-number"
              prepend-icon="mdi-credit-card"
              type="text"
              v-model="state.payment.cc.number"
              :rules="[v => !!v || 'Card Number is required']"
              required
          ></v-text-field>

          <v-text-field
              label="Credit Card First Name"
              name="cc-first-name"
              prepend-icon="mdi-form-textbox"
              type="text"
              v-model="state.payment.cc.firstName"
              :rules="[v => !!v || 'Card first name is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Credit Card Last Name"
              name="cc-last-name"
              prepend-icon="mdi-form-textbox"
              type="text"
              v-model="state.payment.cc.lastName"
              :rules="[v => !!v || 'Card last name is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Expiry (Month/Year, 01/21)"
              name="cc-exp"
              prepend-icon="mdi-calendar-range"
              type="text"
              v-model="state.payment.cc.expiry"
              :rules="[v => !!v || 'Card expiry is required']"
              required
          ></v-text-field>
          <v-text-field
              label="CVV"
              name="cc-cvv"
              prepend-icon="mdi-credit-card-refund"
              type="text"
              v-model="state.payment.cc.cvv"
              :rules="[v => !!v || 'Card cvv is required']"
              required
          ></v-text-field>

        </v-card-text>


      </v-card>
      <v-card outlined class="mt-5">

        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title>Terms and Conditions</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <p>
            Registration: <br>
            By registering for the FVS Annual Meeting, the attendee understands and agrees that attendee’s name, city,
            and state may be shared with other attendees and exhibitors. By allowing an exhibitor to scan the conference
            badge, attendee understands, agrees, and consents to the sharing of the attendee’s full contact information
            with the company sharing the badge. This includes mailing address, phone, and email. By registering for this
            Annual Meeting, I also give FVS the right to publish all photos, videos, etc. taken at this Conference.

          </p>
          <p>
            Cancellation Policy: <br>
            A written notice of cancellation must be received within 30 days of the meeting to receive a refund.
            Cancellations received prior to this date will be honored minus a $100 administration fee. Refunds will not
            be honored within the 30-day timeframe. Telephone cancellations cannot be accepted. Cancellation refunds
            will be processed within 30 days after the conclusion of the meeting.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#488ba6" class='align-right mr-2' style="color:white" @click="back">Edit Order</v-btn>

          <v-btn color="#488ba6" type="submit" style="color:white" :disabled="!valid">Register and Pay
            {{ formTotal.display }}
          </v-btn>
        </v-card-actions>

        <v-alert class="mt-2" type="error" v-if="this.state.payment.response.errorMsg">
          <small>{{ this.state.payment.response.errorMsg }} | Please refresh the page to try again.</small>

        </v-alert>
      </v-card>
    </v-form>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Review from './Review'
import Donation from './Donation'

export default {
  name: "Form",
  data: function () {
    return {
      ccTypes: [
        {
          text: 'Visa',
          val: 'Visa'
        },
        {
          text: 'MasterCard',
          val: 'MC'
        },
        {
          text: 'American Express',
          val: 'AMEX'
        },
      ],
      rsvpAmounts: [
        '',
        1,
        2,
        3,
        4,
        5
      ],
      valid: true,
    }
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
    formattedCancellationCutoff: function () {
      let options = {year: 'numeric', month: 'long', day: 'numeric'};
      let d = new Date(this.state.member.meeting.meetingInfo.start_date);
      d.setMonth(d.getMonth() - 1)
      return d.toLocaleDateString('en-US', options);
    },
    rsvpRequired: function () {
      let r = this.state.member.meeting.extraProductsSelected.filter((p) => {
        if (p.MEETINGPRODUCTID === 6) {
          p.childRsvpRequired = true;
          return p;
        } else if (p.MEETINGPRODUCTID === 5) {
          return p;
        }
      });
      return r;
    },

  },
  methods: {
    submitForm: function () {

      if (this.$refs.regForm.validate()) {
        this.$store.dispatch('saveForm', this.formTotal.intVal);
      }


    },
    back: function () {
      this.$store.commit('editOrder');
    }
  },
  props: [
    'formTotal'
  ],
  components: {
    Review,
    Donation
  }
}
</script>

<style scoped>

</style>